import type { Organization } from '@local/common-lib';
import { useAxios } from '../../hooks/use-axios.js';

export interface CallSignOptions {
  callSigns: string[];
  restrictCallSigns: boolean;
}

/**
 * Call sign options configured for the current user's organization.
 */
export const useCallSigns = (): CallSignOptions => {
  const [organization] = useAxios<Organization.Type>('/api/v1/my/organization');

  return {
    callSigns: organization.data?.callSigns ?? [],
    restrictCallSigns: organization.data?.restrictCallSigns ?? false,
  };
};
